import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import CartAPI from "@/app/api/di-sana/cart/cart";
const cartApi = new CartAPI()

export const loadOrderCount = createAsyncThunk("order/loadOrderCount",
	async (_, thunkAPI) => {
		try {
			const { data } = await cartApi.getOrderCount()
			return data
		} catch (err) {
			return thunkAPI.rejectWithValue(err.response?.data || err.message)
		}
	}
)

const initialState = {
	status: "idle",
	orderCount: 0,
}

const orderSlice = createSlice({
	name: "order",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(loadOrderCount.pending, (state) => {
				state.status = "loading"
			})
			.addCase(loadOrderCount.fulfilled, (state, { payload }) => {
				state.status = "succeeded"
				state.orderCount = payload.data.order_count
			})
			.addCase(loadOrderCount.rejected, (state) => {
				state.status = "failed"
				state.error = payload
			})
	}
})

export default orderSlice.reducer